module.exports = __webpack_public_path__ + "static/media/H OD.1f4fabc6.svg";